module.exports = __webpack_public_path__ + "img/icon-share-facebook.68f020d0.png";